// extracted by mini-css-extract-plugin
export var aboveInput = "_kx-0";
export var actionButton = "_kx-5";
export var actionButtonContainer = "_kx-1";
export var actionIcon = "_kx-6";
export var aiInfoContainer = "_kx-2";
export var attachmentWrapper = "_kx-7";
export var bold = "_kx-3";
export var checkIcon = "_kx-8";
export var clickingRecipientBar = "_kx-11";
export var commentThreadSwitch = "_kx-a";
export var draftImage = "_kx-b";
export var draftImageContainer = "_kx-c";
export var draftImages = "_kx-e";
export var editButton = "_kx-g";
export var editor = "_kx-f";
export var editorContainer = "_kx-y";
export var editorErrorTooltipWrapper = "_kx-9";
export var headerDivider = "_kx-h";
export var icon = "_kx-i";
export var info = "_kx-j";
export var internal = "_kx-n";
export var internalDivider = "_kx-k";
export var internalMessage = "_kx-l";
export var messageInputCard = "_kx-m";
export var messageInputForm = "_kx-o";
export var messageInputFormInternal = "_kx-p";
export var options = "_kx-q";
export var publicMessageCustomer = "_kx-s";
export var publicMessageMerchant = "_kx-r";
export var removeImageButton = "_kx-d";
export var replyButtons = "_kx-t";
export var showSignatureButton = "_kx-u";
export var spinner = "_kx-v";
export var verticalButtonDivider = "_kx-4";
export var visibilitySelector = "_kx-w";
export var warning = "_kx-x";
export var wrappingText = "_kx-z";
export var writingInternalNoteTopBorder = "_kx-10";